var map = {
	"./locales/en": 56,
	"./locales/en.svg": 56,
	"./locales/fi": 57,
	"./locales/fi.svg": 57,
	"./lonna_bg": 58,
	"./lonna_bg.jpg": 58,
	"./sauna_bg": 59,
	"./sauna_bg.jpg": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;